import Intro from './Components/js/Intro';
import Skills from './Components/js/Skills';
import Project from './Components/js/Project';
import Hobbies from './Components/js/Hobbies';
const Homepage = ()=>{
    return(
        <>
            <Intro />
            <Skills />
            <Project />
            <Hobbies />
        </>
    )
}
export default Homepage;

// #3d37ff
// #9787bb
// #f8ebff
// #67baa7
